import React from "react";
import Button from "../../Shared/Button/Button";
import UserInfo from "./UserInfo";

const Details = ({ itemType }) => {
  let remainingTime = "0 Day 00:00:00";
  if (itemType === "Active Listing") {
    remainingTime = "1 Day 18:44:05";
  }

  if (itemType === "Review") {
    return (
      <div className="flex flex-col items-center justify-center border-l border-lightGray py-4">
        <p className="mb-9 font-pop text-xl font-semibold text-blue">
          Auction Bob
        </p>
        <Button text={"View Item"} variant="primary" />
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center gap-1.5 border-l border-lightGray py-4">
      {itemType === "Active Listing" && <UserInfo />}

      <p className="font-pop text-sm font-semibold text-primary">
        Remaining Time: {remainingTime}
      </p>

      <Button text={"Outbid"} variant="outline" />
      <Button text={"Top Bid R150,056.00"} variant="blue" />
      <Button text={"View Item"} variant="secondary" />
    </div>
  );
};

export default Details;
